import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgRight = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path d="M8.458 5.283a.4.4 0 00-.566 0l-.61.61a.4.4 0 000 .565L10.817 10l-3.535 3.542a.4.4 0 000 .566l.61.61a.4.4 0 00.566 0l4.434-4.435a.4.4 0 000-.566L8.458 5.283z" />
    </Icon>
  );
};

export default SvgRight;
